import request from 'request/index'
import { E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
   * 3.5.1 获取系统语言列表 [get] /visitor/system_language?$count=false&$offset=偏移量&$limit=数量
   */
  sGetLanguage ({
    $count = false,
    $offset = 0,
    $limit = 10
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/system_language',
      query: {
        $count,
        $limit,
        $offset
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/language.js